let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5l9VY")).then(() => parcelRequire('4fJWm'));